module.exports = __webpack_public_path__ + "img/password_reset_fe.657724bc.png";